export default "__VITE_ASSET__QRTyMuZP__"